import React, { useEffect, useState } from 'react';
import { Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { CarOutlined, DollarOutlined } from '@ant-design/icons';

import type { MenuProps } from 'antd';

type MenuItem = Required<MenuProps>['items'][number];

function getItem(
  label: string,
  url: string,
  icon?: React.ReactNode,
  isHeader?: boolean,
  children?: MenuItem[],
  type?: 'group',
): MenuItem {
  const menuItem: MenuItem = {
    key: url,
    icon: icon,
    children: children,
    label: !isHeader ? <Link to={url}>{label}</Link> : <>{label}</>,
    type: type,
  };

  return menuItem;
}

const MainMenu: React.FC = () => {
  const items: MenuItem[] = [
    getItem('Vehicles', '/', <CarOutlined />, true, [getItem('My Vehicles', '/vehicles')]),
    getItem('Auctions', '/auctions', <DollarOutlined />, true, [
      getItem('Next Auction', '/auctions/next'),
      getItem('Live Auction', '/auctions/live'),
    ]),
  ];

  const location = useLocation();
  const [current, setCurrent] = useState(location.pathname);

  useEffect(() => {
    if (location.pathname) {
      if (current !== location.pathname) {
        setCurrent(location.pathname);
      }
    }
  }, [location, current]);

  return (
    <Menu
      mode='inline'
      items={items}
      defaultOpenKeys={['/', '/vehicles', '/auctions']}
      defaultSelectedKeys={['/vehicles']}
      selectedKeys={[current]}
    />
  );
};

export default MainMenu;
